// extracted by mini-css-extract-plugin
module.exports =  {"buttonsWrapper":"ChatFeedbackButtons-module__buttonsWrapper--kisrq"};